const CheckIcon = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#666",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="12586"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m0 964.923077a452.923077 452.923077 0 1 1 452.923077-452.923077 452.923077 452.923077 0 0 1-452.923077 452.923077z"
      fill={color}
      p-id="12587"
    ></path>
    <path
      d="M393.649231 643.347692l-139.224616-139.224615-55.72923 55.729231 194.953846 194.756923L825.304615 322.953846l-55.72923-55.532308-375.926154 375.926154z"
      fill={color}
      p-id="12588"
    ></path>
  </svg>
);

export default CheckIcon;
